<app-protected-content [requiredRoles]="requiredRoles">
  <div class="container" *transloco="let t; prefix: 'organization.member.detail'">
    <htx-button variant="tertiary" icon="arrow_back" (click)="backToList()">{{
      'button.back' | transloco
    }}</htx-button>

    <div class="panel">
      <div class="header-section">
        <div class="header-title-section">
          <h1 class="header-title">{{ 'organization.member.detail.header' | transloco }}</h1>
          <p class="header-subtitle">{{ 'organization.member.detail.sub-header' | transloco }}</p>
        </div>
        <htx-button variant="tertiary" icon="edit" (click)="edit()" [disabled]="isOrganizationPending()">{{
          'button.edit' | transloco
        }}</htx-button>
      </div>

      <htx-data-display
        [title]="t('memberDetails')"
        [icon]="'person'"
        [data]="(memberDetails$ | async) ?? []"
      ></htx-data-display>
    </div>
  </div>
</app-protected-content>

<ng-template #rolesTemplate>
  <div class="role-badges">
    @for (role of (memberRoles$ | async) || []; track role) {
      <htx-badge
        [text]="'organization.member.roles.labels.' + role | transloco"
        variant="tertiary"
      ></htx-badge>
    }
  </div>
</ng-template>
